import Vue from "vue";
import VueI18n from "vue-i18n";
import ko from "@/locales/ko.js";
import en from "@/locales/en.js";

Vue.use(VueI18n);

const {
    VUE_APP_I18N_LOCALE = "ko",
    VUE_APP_I18N_FALLBACK_LOCALE: fallbackLocale = "en"
} = process.env;

const { searchParams } = new URL(location);
let hl = searchParams.get("hl");
if (!hl) {
    const language = navigator.language || navigator.browserLanguage;
    if (language) [hl] = language.split("-");
}
const locale = hl || VUE_APP_I18N_LOCALE;

export default new VueI18n({
    locale,
    fallbackLocale,
    messages: { ko, en }
});
